import { caloTheme } from 'src/theme/calo';

import { Box, Card, Typography } from '@mui/material';

interface MetricCardProps {
  title: string;
  value: string | number | React.ReactNode;
  icon?: React.ReactNode;
}

const MetricCard = ({ title, value, icon }: MetricCardProps) => (
  <Card
    sx={{
      padding: '24px',
      backgroundColor: caloTheme.palette.primary500,
      borderRadius: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      textWrap: 'wrap',
      minHeight: '120px',
      justifyContent: 'center'
    }}
  >
    <Typography
      sx={{
        fontSize: { xs: '18px', sm: '21px' },
        lineHeight: 1
      }}
      color={caloTheme.palette.white}
    >
      {title}
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
      {icon}
      <Typography
        color={caloTheme.palette.white}
        variant="h4"
        sx={{ fontWeight: 600 }}
      >
        {value}
      </Typography>
    </Box>
  </Card>
);

export default MetricCard; 